/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { ThemeProvider } from '@mui/material/styles';
import { memo } from "react";
import { useSelector } from "react-redux";
import { selectBASECurrentLayoutConfig, selectNavbarTheme } from "../../../store/BASE/settingsSlice";
import { selectBASENavbar } from "../../../store/BASE/navbarSlice";
import NavbarStyle from "./navbar/NavbarStyle";
import NavbarToggleFab from "../../shared-components/NavbarToggleFab";

function NavbarWrapperLayout(props) {
  const config = useSelector(selectBASECurrentLayoutConfig);
  const navbar = useSelector(selectBASENavbar);

  const navbarTheme = useSelector(selectNavbarTheme);

  return (
    <>
      <ThemeProvider theme={navbarTheme}>
        <NavbarStyle />
      </ThemeProvider>

      {config.navbar.display && !config.toolbar.display && !navbar.open && (
        <NavbarToggleFab />
      )}
    </>
  );
}

export default memo(NavbarWrapperLayout);
